import Vue from 'vue'
import VueI18n from 'vue-i18n'
import getBrowserLocale from "@/services/i18n/browserLocal"
import { supportedLocalesInclude } from "./i18n/supportedLocals"

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export const selectedLocale = sessionStorage.getItem("userSelectedLocale") ||
    getStartingLocale() || process.env.VUE_APP_I18N_LOCALE || 'en'

function getStartingLocale() {

  const browserLocaleWithCode = getBrowserLocale()
    console.log("browserLocaleWithCode: "  + browserLocaleWithCode)

    const browserLocale = getBrowserLocale({countryCodeOnly: true})
    console.log("browserLocale: "  + browserLocale)

    if (supportedLocalesInclude(browserLocaleWithCode)) {
    return browserLocaleWithCode;
  } else if (supportedLocalesInclude(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en"
  }
}

export default new VueI18n({
  locale: selectedLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
